import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  container: {
    alignSelf: 'stretch',
  },
  textInputArea: {
    flexDirection: 'row',
    borderRadius: 18,
    alignItems: 'center',
    justifyContent: 'flex-end',
    overflow: 'hidden',
  },
});
